export default __webpack_public_path__ + "static/media/school-img.dadb7479.png";